import React, { memo } from "react";
import classNames from "classnames/bind";
import styles from "../AuthModal.module.scss";
import FormField from "./FormField";
import { LoginExtras, ModeSwitcher } from "./FormExtras";
import { FORM_MODES } from "../../../config/authModalConfig/constants";
import useTranslations from "../../../hooks/useTranslations";

const cx = classNames.bind(styles);

const AuthForm = memo(
  ({
    formConfig,
    modeForm,
    formData,
    errors,
    touched,
    error,
    rememberLogIn,
    setRememberLogIn,
    isFormValid,
    isLoading,
    onInputChange,
    onInputBlur,
    onSubmit,
    onChangeMode,
  }) => {
    const currentTranslations = useTranslations();

    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit();
    };

    return (
      <form className={cx("auth__form")} onSubmit={handleSubmit}>
        <div
          className={cx("form__fields", {
            "form__fields--register": modeForm === FORM_MODES.REGISTER,
          })}
        >
          {formConfig.fields.map((field) => (
            <FormField
              key={field.name}
              field={field}
              value={formData[field.name]}
              error={errors[field.name]}
              touched={touched[field.name]}
              onChange={onInputChange}
              onBlur={onInputBlur}
            />
          ))}
        </div>

        {/* Display auth store error */}
        {error && (
          <div className={cx("auth__error")}>
            <span className={cx("error__message")}>{error}</span>
          </div>
        )}

        {modeForm === FORM_MODES.LOGIN && (
          <LoginExtras
            rememberLogIn={rememberLogIn}
            setRememberLogIn={setRememberLogIn}
            onForgotPassword={() => onChangeMode(FORM_MODES.FORGOT_PASSWORD)}
            translations={currentTranslations}
          />
        )}

        <button
          type="submit"
          className={cx("submit__button", {
            "submit__button--disabled": !isFormValid || isLoading,
          })}
          disabled={!isFormValid || isLoading}
        >
          {isLoading
            ? currentTranslations?.Authen?.Process
            : formConfig.submitText}
          {/* {formConfig.submitText} */}
        </button>

        <ModeSwitcher
          modeForm={modeForm}
          onChangeMode={onChangeMode}
          translations={currentTranslations}
        />
      </form>
    );
  }
);

AuthForm.displayName = "AuthForm";

export default AuthForm;
